// BoxAlong (Holdings) fixed category taxonomy — two groups split by a divider.
export const HOLDINGS_GROUPS = [
  { categories: ["Alternative Assets", "Bonds and Notes", "Cryptocurrencies"] },
  { categories: ["Mobility Property", "Equities", "Real Estate", "Land", "Options", "Trusts and Tangents"] },
];

export const HOLDINGS_CATEGORIES = HOLDINGS_GROUPS.flatMap((g) => g.categories);

// Defined sub-sections per category. Categories omitted here take a free-typed sub-section.
export const HOLDINGS_SUBSECTIONS = {
  "Mobility Property": ["Aircraft", "Vessels", "Vintage cars", "Muscle cars", "Seacraft", "Rotary and Minicraft", "Bikes"],
  "Bonds and Notes": ["Short Notes", "Long Notes"],
  "Equities": [
    "Agentics, Space, AI",
    "Communications Services",
    "Conglomerates",
    "Consumer Discretionary",
    "Consumer Staples",
    "Energy",
    "Financials",
    "Healthcare",
    "Industrials",
    "I.T. and Infotainment",
    "Materials",
    "Real Estate",
    "Robotics, Augmentation, Defence",
    "Transportation and Logistics",
    "Utilities",
  ],
};

export const HOLDINGS_GROUP_CONFIG = {
  groups: HOLDINGS_GROUPS,
  categories: HOLDINGS_CATEGORIES,
  subsections: HOLDINGS_SUBSECTIONS,
  categoryKey: "category",
  subKey: "subcategory",
};
